/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_BirthdayInputs */

const vi_grower_birthday = /** @type {(inputs: Grower_BirthdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày sinh`)
};

/**

* @param {Grower_BirthdayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_birthday = /** @type {((inputs?: Grower_BirthdayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_BirthdayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_birthday(inputs)
});